import { observable } from 'mobx';
import { Sampler } from "tone";
import correctSound from './audio/correct.mp3';
import incorrectSound from './audio/incorrect.mp3';
import { observableSingleStore } from '../stores/single-store';
import { observableIntervalStore } from '../stores/interval-store';
import { observableChordStore } from '../stores/chord-store';
import { observableProgressStore } from '../stores/user-level-progress-store';
const  ReactGA = require('react-ga');

class GameStore {
  @observable level = 1;
  @observable currentStore = observableSingleStore;
  // @observable currentStore = observableChordStore;
  @observable score = 0;
  @observable correctReady = false;
  @observable incorrectReady = false;
  @observable mode = "easy";
  @observable correctCount = 0;
  @observable incorrectCount = 0;
  @observable lives = 3;
  @observable showCorrect = false;
  @observable showIncorrect = false;
  @observable gameIsOver = false;
  @observable showClearedMessage = false;
  constructor() {
    this.correctSampler = new Sampler(correctSound, () => {
      this.correctReady = true;
    }).toMaster();
    this.incorrectSampler = new Sampler(incorrectSound, () => {
      this.incorrectReady = true;
    }).toMaster();
    this.resetGame();
  }
  resetGame = () => {
    this.lives = 3;
    this.score = 0;
    this.level = 1;
    observableSingleStore.stages = [];
    observableIntervalStore.stages = [];
    observableChordStore.stages = [];
    this.currentStore = observableSingleStore;
    this.currentStore.getNewStage();
      ReactGA.event({
          category: 'Game',
          action: 'Started'
      });
  }

  wrongPitchPlayed(noPenalty) {
    if (this.level >= 4 && !noPenalty) {
      this.processIncorrect();
    }
  }

  goToNextLevel() {
    this.showClearedMessage = false;
    this.level++;
    if (this.level === 2) {
      this.currentStore = observableIntervalStore;
    }
    else if (this.level === 3) {
      this.currentStore = observableChordStore;
    }
    else if (this.level === 4) {
      this.currentStore = observableChordStore;
    }
    else {
      this.currentStore = observableSingleStore;
    }
    this.currentStore.getNewStage();
  }

  checkAnswer() {
    const correct = this.currentStore.currentStage.checkAnswer();
    if (correct) {
      this.correctCount++;
      this.score++;
      this.showCorrect = true;
      this.correctSampler.triggerAttack();
      setTimeout(() => {
        this.showCorrect = false;
      }, 200);
      if (this.level < 4) {
      if (this.currentStore.numberCorrect >= this.currentStore.passThresh) {
        if (!observableProgressStore.state[this.level]) {
          this.showClearedMessage = true;
        }
        observableProgressStore.markLevelPassed(this.level);
        ReactGA.event({
          category: 'Game',
          action: 'Level Passed',
          value: this.level
        });
      }
      if (this.currentStore.numberCorrect >= this.currentStore.passThresh) {
        if (!observableProgressStore.state[this.level]) {
          this.showClearedMessage = true;
        }
        observableProgressStore.markLevelPassed(this.level);
        ReactGA.event({
          category: 'Game',
          action: 'Level Passed',
          value: this.level
        });
      }
      if (this.currentStore.numberCorrect >= this.currentStore.passThresh) {
        if (!observableProgressStore.state[this.level]) {
          this.showClearedMessage = true;
        }
        observableProgressStore.markLevelPassed(this.level);
        ReactGA.event({
          category: 'Game',
          action: 'Level Passed',
          value: this.level
        });
      }
    }
      this.currentStore.getNewStage();
      return true;
    }
    else {
      this.processIncorrect();
      return false;
    }
  }
  processIncorrect() {
    this.incorrectCount++;
    this.incorrectSampler.triggerAttack();
    this.lives--;
    this.showIncorrect = true;
    setTimeout(() => {
      this.showIncorrect = false;
    }, 200);
    if (this.lives <= 0) {
      this.gameIsOver = true;
    }
  }

  incrementScore() {
    this.score++;
  }

}
export const observableStore = new GameStore();



// WEBPACK FOOTER //
// ./src/stores/game-store.js